exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".subscribed-channels-template[data-v-849d280c]{min-height:100px;margin-top:-35px}", ""]);

